


































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { CLEAR_TIMEZONE } from '@/system/store/action-types'
import { GET_ISSUES, GET_SELECTED_TZ } from '@/system/store/getter-types'
import { IIssue } from '@/features/matchFields/store'
import { matchFieldsLocalisationKeys } from '@/features/matchFields/matchFields.localisation'
import { IActionType } from '@/system/store'
import * as moment from 'moment-timezone'

@Component
export default class MatchFieldsIssues extends Vue {
  private translations = matchFieldsLocalisationKeys
  private chooseTimezone: boolean = false
  private timeZones: string[] = []

  columns = [{
    name: 'type',
    field: ({ type }: IIssue) => type,
    align: 'left'
  }, {
    name: 'message',
    field: ({ message }: IIssue) => message,
    align: 'left'
  }]

  @Action(CLEAR_TIMEZONE)
  clearTimezone!: IActionType
  @Getter(GET_ISSUES)
  issues!: IIssue[]
  @Getter(GET_SELECTED_TZ)
  selectedTz!: string

  private destroyed () {
    this.clearTimezone()
  }

  get getTz () {
    return this.selectedTz ? moment.tz(this.selectedTz).utcOffset() / 60 : '0'
  }

  private showDialog (): void {
    this.$emit('chooseTz')
  }
}
